import type { MeResponse } from '@lyra/shared';

/** Client-side mirror of the server's `requireNomenclatorEdit` gate
 *  (server/src/services/permissions.ts: `hasPermission` + `isOrgAdminRole`)
 *  — used to show/hide the catalog's create/edit/delete affordances. This is
 *  a UX convenience only; the server re-checks on every write, so a stale or
 *  spoofed client value can never bypass enforcement. */
export function canEditNomenclator(me: MeResponse | undefined): boolean {
  return !!me && (me.orgRole === 'owner' || me.orgRole === 'admin' || me.permissions.includes('nomenclator.edit'));
}

/** Billing-privacy policy: only org owners/admins and platform admins may see
 *  EUR balances, rates and costs. Regular members must not. Mirrors the server
 *  gate (`canSeeBilling` in server/src/services/permissions.ts) — UX only; the
 *  server refuses/omits money regardless of this value, so it can't be bypassed. */
export function canSeeBilling(me: MeResponse | undefined): boolean {
  return !!me && (me.orgRole === 'owner' || me.orgRole === 'admin' || me.globalRole === 'platform_admin');
}
